// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"f929bac9","535":"75643640","877":"3d995c70","967":"4234e3f2"}[chunkId] + ".chunk.js";
};